/* Phones: the hero film is a sharp square in the middle of the screen; the same film, drawn small and blurred
   behind it, fills the rest so the picture runs edge to edge with no frame. One video decode: the backdrop is a
   tiny canvas copied from the playing video each frame. */
(function () {
  var mq = window.matchMedia && window.matchMedia("(max-width: 767px)");
  var box = document.querySelector(".hero__films--one"), v = box && box.querySelector("video");
  if (!mq || !box || !v) return;
  var c = document.createElement("canvas"); c.className = "hero__amb"; c.width = 48; c.height = 80; c.setAttribute("aria-hidden", "true");
  box.insertBefore(c, box.firstChild);
  var ctx = c.getContext("2d"), on = true;
  new IntersectionObserver(function (es) { on = es[0].isIntersecting; }).observe(box);
  (function tick() {
    if (mq.matches && on && v.readyState >= 2) { try { ctx.drawImage(v, 0, 0, c.width, c.height); } catch (e) {} }
    requestAnimationFrame(tick);
  })();
})();
